import { Route, Switch } from "react-router-dom";
import BrandProductInsightsPage from "@faire/prototype-playground/workspace/awe/brand-product-insights";
import PdpBrandRefinementAccentColorsPage from "@faire/prototype-playground/workspace/awe/pdp-brand-refinement-accent-colors";
import TopReorderedListPagePage from "@faire/prototype-playground/workspace/awe/top-reordered-list-page";
import { withCompass } from "../../components/compass/withCompass";

const BpCatNavExplorationsPage = withCompass(
  () =>
    import(
      "@faire/prototype-playground/workspace/awe/bp-cat-nav-explorations/Page"
    )
);
const PriceVerificationGoodMarginFlagPage = withCompass(
  () =>
    import(
      "@faire/prototype-playground/workspace/awe/price-verification-good-margin-flag/Page"
    )
);

export function AneleseWebskiRoutes() {
  return (
    <Switch>
      <Route path="/awe/bp-cat-nav-explorations" component={BpCatNavExplorationsPage} />
      <Route path="/awe/brand-product-insights" component={BrandProductInsightsPage} />
      <Route path="/awe/pdp-brand-refinement-accent-colors" component={PdpBrandRefinementAccentColorsPage} />
      <Route path="/awe/price-verification-good-margin-flag" component={PriceVerificationGoodMarginFlagPage} />
      <Route path="/awe/top-reordered-list-page" component={TopReorderedListPagePage} />
    </Switch>
  );
}

export const slug = "awe";
